import { GripHorizontal, Pencil, Trash } from 'lucide-react';
import Button from '../../../components/Button';
import type { OcdTheme } from '../services/settingsTypes';

interface OcdThemeRowProps {
  theme: OcdTheme;
  index: number;
  isDragging: boolean;
  onDragStart: (index: number) => void;
  onDragOver: (e: React.DragEvent, index: number) => void;
  onDragEnd: () => void;
  onEdit: (theme: OcdTheme) => void;
  onDelete: (theme: OcdTheme) => void;
}

export const OcdThemeRow = ({
  theme,
  index,
  isDragging,
  onDragStart,
  onDragOver,
  onDragEnd,
  onEdit,
  onDelete,
}: OcdThemeRowProps) => {
  return (
    <div
      draggable
      onDragStart={() => onDragStart(index)}
      onDragOver={(e) => onDragOver(e, index)}
      onDragEnd={onDragEnd}
      className={`bg-white border border-gray-200 rounded-lg p-2 flex items-center justify-between hover:shadow-md transition-shadow cursor-move ${isDragging ? 'opacity-50' : ''
        }`}
    >
      <div className="flex items-center gap-4 flex-1 min-w-0">
        <div className="text-gray-400">
          <GripHorizontal size={16} />
        </div>
        <div className="flex-1 min-w-0">
          <div className="font-sm text-gray-900 break-words">{theme.friendlyName} <span className="text-xs text-gray-500">({theme.key})</span></div>
        </div>
      </div>
      <div className="flex gap-2 ml-4">
        <Button
          onClick={() => onEdit(theme)}
          size="sm"
          icon={<Pencil size={16} />}
        />
        <Button
          onClick={() => onDelete(theme)}
          variant="danger"
          size="sm"
          icon={<Trash size={16} />}
        />
      </div>
    </div>
  );
};

